
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Glucksberg',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Glucksberg.vue